import { createAction } from '@reduxjs/toolkit';

export const videosUpdateRequest = createAction('emailsVideos/updateRequest');
export const videosUpdateError = createAction('emailsVideos/updateError');
export const videosUpdateStore = createAction('emailsVideos/updateStore');

export const videosStore = createAction('emailsVideos/store');
export const videosClear = createAction('emailsVideos/clear');

export const videosUpdateTitle = createAction('emailsVideos/updateTitle');
export const videosUpdateDescription = createAction('emailsVideos/updateDescription');
export const videosUpdateShowPlayIcon = createAction('emailsVideos/updateShowPlayIcon');
export const videosUpdateTextAlign = createAction('emailsVideos/updateTextAlign');
export const videosUpdateLayout = createAction('emailsVideos/updateLayout');
export const videosUpdateItems = createAction('emailsVideos/updateItems');

export const videosAddItemRequest = createAction('emailsVideos/addItemRequest');
export const videosUpdateItemRequest = createAction('emailsVideos/updateItemRequest');
export const videosDeleteItemRequest = createAction('emailsVideos/deleteItemRequest');
